const WebPushes = function(dispatcher, options) {

    this.popup = null;
    this.popupWebPush = '';

    this.init = () => {
        if (typeof webPushesEnabled === "undefined") {
            return;
        }
        if (webPushesEnabled) {
            this.createBlankOverlay();
            this.showOverlay();
            this.openWebPush();

            document.getElementById("web-push-ok").addEventListener("click", (event) => {
                this.closeWebPush();

                return false;
            });
        }
    }

    this.sendDoNotDisplay = () => {
        if (typeof webPushesDoNotDisplay === "undefined") {
            return;
        }
        const xhttp = new XMLHttpRequest();
        xhttp.open("POST", webPushesDoNotDisplay + "/" + webPushesTemplateName + "/" + userID, true);
        xhttp.send();
    }

    this.openWebPush = () => {
        this.popupWebPush = document.getElementById('webPush');
        this.popupWebPush.style.display = "block";
    }

    this.closeWebPush = () => {
        this.hideOverlay();
        if (!this.popupWebPush) {
            return;
        }
        this.popupWebPush.style.display = "none";
        const checkbox = document.getElementById("web-push-do-not-display")
        if (checkbox && checkbox.checked) {
            this.sendDoNotDisplay();
        }
    }

    this.createBlankOverlay = () => {
        if (document.getElementById('mainOverlay') !== null) {
            return;
        }
        const overlayDiv = document.createElement("div");
        overlayDiv.setAttribute('id', 'mainOverlay');
        document.body.appendChild(overlayDiv);
    };

    this.showOverlay = () => {
        document.getElementById("mainOverlay").style.display = "block";
        document.body.classList.add("no-scroll");
    };

    this.hideOverlay = () => {
        document.getElementById("mainOverlay").style.display = "none";
        document.body.classList.remove("no-scroll");
    };
    document.addEventListener("DOMContentLoaded", () => {
        document.body.addEventListener("click", function(event) {
            if (event.target.id === 'mainOverlay') {
                this.closeWebPush();
            }
        }.bind(this));
    });
};

export { WebPushes }
